<template>
  <div class="campaign-top">
    <!-- サークルインディケータの表示コンポーネント -->
    <Loading v-show="loading" />

    <!-- 抽選済みの場合に表示する -->
    <div v-show="lotteryResult">
      <CampaignVideo :videoPath="resultVideo" :play="lotteryVideoStart" />
      <div class="campaign-text-wrap">
        <p class="mt10">
          お買い物ポイントがウォレットに付与されるまで、楽しみにお待ちください。
        </p>
        <p class="campaign-text mt12">
          お買い物ポイントはウォレット内の残高と同じように1円からお使いいただけます。<br />ウォレットへのポイント付与は2024年1月中に実施いたします。
        </p>
      </div>
    </div>

    <!-- 未抽選の場合に表示する -->
    <div v-show="!lotteryResult">
      <!-- 未抽選の人の抽選中に表示する動画 -->
      <div v-show="loadingVideo">
        <CampaignVideo
          :videoPath="
            require('@/assets/images/newyear/2024/before_omikuji.mp4')
          "
          :play="videoControl"
          @endVideo="handleCheckEndVideo"
        />
        <div class="skip-button campaign-button">
          <BaseBtnDetail
            :button_text="'動画をスキップして結果を確認する'"
            :back_color="buttonSkipBackground"
            :border_radius="'10px'"
            :border="false"
            :font_weight="'bold'"
            :disabled="!checkSkip"
            @handleClick="handleSkip"
            @endVideo="handleCheckEndVideo"
          />
        </div>
      </div>

      <!-- おみくじ画面表示用 -->
      <div v-show="!loadingVideo">
        <CampaignOmikujiHeader />
        <div class="campaign-button">
          <BaseBtnDetail
            :button_text="'おみくじをひく'"
            :back_color="buttonBackColor"
            :border_radius="'10px'"
            :border="false"
            :disabled="!available"
            :font_weight="'bold'"
            @handleClick="handleLottely"
          />
        </div>
        <div class="campaign-text-wrap">
          <p class="campaign-text">
            上のボタンを押しておみくじを引いてください。<br />おみくじの結果によってお買い物ポイントをもれなくプレゼントいたします！
          </p>
          <p class="campaign-text">大吉:10,000円分のお買い物ポイント</p>
          <p class="campaign-text">中吉:1,000円分のお買い物ポイント</p>
          <p class="campaign-text">小吉:100円分のお買い物ポイント</p>
        </div>
        <div class="campaign-text-wrap">
          <p class="campaign-text">
            【おみくじ実施期間】2024年1月15日(月)まで
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/common/Loading";
import BaseBtnDetail from "@/components/common/BaseBtnDetail";
import CampaignVideo from "@/components/campaign/CampaignVideo";
import CampaignOmikujiHeader from "@/components/campaign/CampaignOmikujiHeader";
import CampaignOmikuji from "@/components/api/campaign/omikujiCampaign";

export default {
  components: { Loading, BaseBtnDetail, CampaignVideo, CampaignOmikujiHeader },
  data() {
    return {
      loading: false, // 初回描画時のloadingフラグ
      available: false, // 期限切れのフラグ
      loadingVideo: false, // 抽選結果が出るまでのloading用の動画フラグ
      lotteryResult: false, // 抽選結果表示するフラグ
      checkSkip: false, //skipボタン使用可能かの確認フラグ
      apiStatus: false, //API取得できたかどうか判定するフラグ
      videoControl: false, //videoの再生を判定するフラグ
      lotteryVideoStart: false,
      resultVideo: "", //おみくじの結果動画のURL
      message: "", // errorメッセージ
      userId: 0
    };
  },

  // 値によってボタンの色を変更する
  computed: {
    buttonBackColor() {
      return this.available ? "#007bff" : "#595959";
    },
    buttonSkipBackground() {
      return this.checkSkip ? "#007bff" : "#595959";
    }
  },

  methods: {
    // スキップボタン押した時に走る処理
    handleSkip() {
      this.lotteryResult = true;
      this.$nextTick(() => {
        this.lotteryVideoStart = true;
      });
    },

    // 動画が終わった時に走る処理
    handleCheckEndVideo() {
      this.videoControl = false;
      if (this.resultVideo) {
        this.lotteryResult = true;
        this.$nextTick(() => {
          this.lotteryVideoStart = true;
        });
      } else {
        this.videoControl = false;
        // nextTickでDOMを更新する非同期関数が全て終わってから再度ビデオを再生するようにtrueを与えている
        this.$nextTick(() => {
          this.videoControl = true; // Vueの次のDOM更新後に再生を再開
        });
      }
    },

    // おみくじ引くボタン押した時の処理
    async handleLottely() {
      this.loadingVideo = true;
      this.videoControl = true;
      try {
        let res = await CampaignOmikuji.getCampaignOmikujiResult(this.userId);
        if (res.status == "OK") {
          this.resultVideo = res.resultFileUrl ? res.resultFileUrl : "";
          this.apiStatus = true;
          this.checkSkip = true;
        } else {
          this.message = res.message;
          this.$router.push({
            name: "CampaignOmikujiError",
            params: { errorMessage: this.message, userId: this.userId }
          });
        }
      } catch (error) {
        console.log(error);
        this.$router.push({
          name: "CampaignOmikujiError",
          params: {
            errorMessage: "エラーが発生しました。初めからやり直してください。",
            userId: this.userId
          }
        });
      }
    }
  },

  async mounted() {
    this.loading = true;
    this.userId = this.$route.params.id;
    try {
      let res = await CampaignOmikuji.getCampaignOmikuji(this.userId);
      if (res.entered) {
        this.lotteryResult = false
        this.resultVideo = res.result ? res.result.resultFileUrl : "";
        this.loadingVideo = true
        this.videoControl = true
      }
      console.log(res);
      this.available = res.available;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style lang="css" scoped>
.campaign-top {
  background-color: white;
  height: 100vh;
}
.campaign-button {
  padding: 30px 40px 10px 40px;
}
.campaign-text-wrap {
  padding: 10px 20px 10px 20px;
}
.campaign-text {
  padding: 5px;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/views/omikujiTest/OmikujiTest.vue